import { NavBar, Footer, GetReady, Map, whatsapp } from "../../Components/ExportComponents";
import { Link } from "react-router-dom";
import "./Contact.css";
import { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const Contact = ({ fullNav }) => {

    const { text } = useParams(); // will be undefined if just /contact

    // Declare Input
    const [fullname, setFullname] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [courseselect, setCourse] = useState("");
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");

    const [load, setLoad] = useState(false);

    // Error states
    const [fullnameError, setFullnameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [courseError, setCourseError] = useState("");
    const [dateError, setDateError] = useState("");
    const [timeError, setTimeError] = useState("");
    const [fetchError, setFetchError] = useState("")

    // Refs for scrolling
    const fullnameRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const courseRef = useRef(null);
    const dateRef = useRef(null);
    const timeRef = useRef(null);

    // For Open Custom Drop Down
    const [dropdown, setDropDown] = useState(false);

    // For Sent 
    const [success, setSuccess] = useState(false);
    const [inputFields, setInputFields] = useState(true);


    const [focused, setFocused] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        if (focused && inputRef.current) {
            inputRef.current.focus();
        }
    }, [focused]);



    const divSecond = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                divSecond.current &&
                !divSecond.current.contains(event.target)
            ) {
                console.log("Clicked outside the div");
                setDropDown(false);
            }
        }

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    // Realtime field validation
    const validateField = (name, value) => {
        switch (name) {
            case "fullname":
                if (!value.trim()) setFullnameError("Full name is required");
                else setFullnameError("");
                break;

            case "email":
                if (!value.trim()) setEmailError("Email is required");
                else if (!/\S+@\S+\.\S+/.test(value)) setEmailError("Enter a valid email");
                else setEmailError("");
                break;

            case "phone":
                if (!value.trim()) setPhoneError("Phone is required");
                else if (!/^[0-9]{10}$/.test(value)) setPhoneError("Phone must be 10 digits");
                else setPhoneError("");
                break;

            case "courseselect":
                if (!value.trim()) setCourseError("Course is required");
                else setCourseError("");
                break;

            case "date":
                if (value.trim() && !/^[0-9/-]+$/.test(value)) {
                    setDateError("Invalid date format");
                } else {
                    setDateError("");
                }
                break;

            case "time":
                if (value.trim() && !/^[0-9:\sAPMapm]+$/.test(value)) {
                    setTimeError("Invalid time format");
                } else {
                    setTimeError("");
                }
                break;

            default:
                break;
        }
    };

    const validateForm = () => {
        validateField("fullname", fullname);
        validateField("email", email);
        validateField("phone", phone);
        validateField("courseselect", courseselect);
        validateField("date", date);
        validateField("time", time);

        return (
            fullname.trim() &&
            email.trim() && /\S+@\S+\.\S+/.test(email) &&
            phone.trim() && /^[0-9]{10}$/.test(phone) &&
            courseselect.trim() &&
            (!date.trim() || /^[0-9/-]+$/.test(date)) &&
            (!time.trim() || /^[0-9:\sAPMapm]+$/.test(time))
        );
    };

    const submitForm = async () => {

        if (validateForm()) {
            // console.log("✅ Form submitted:", { fullname, email, phone, courseselect, date, time });
            setLoad(true);
            try {
                const local = "http://localhost:5000/mailRequest";
                const global = "https://api.scale-upacademy.com/mailRequest"
                const response = await fetch(global, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        fullname,
                        email,
                        phone,
                        courseselect,
                        date,
                        time
                    }),
                });

                const data = await response.json();

                if (data.success) {
                    console.log("Email sent successfully");
                    setSuccess(true)
                } else {
                    setFetchError("Error sending email:", data.message)
                    console.log("Error sending email:", data.message);
                }
            } catch (err) {
                console.log(err.message);
                setFetchError(err.message);

            }
            setLoad(false)


        } else {
            // Scroll to first error
            if (fullnameError && fullnameRef.current) fullnameRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            else if (emailError && emailRef.current) emailRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            else if (phoneError && phoneRef.current) phoneRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            else if (courseError && courseRef.current) courseRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            else if (dateError && dateRef.current) dateRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            else if (timeError && timeRef.current) timeRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };
    const topSc = useRef(null);
    useEffect(() => {
        if (success) {
            setInputFields(false);
            topSc.current.scrollIntoView({ behavior: "smooth", block: "center" })
            setTimeout(() => {
                setSuccess(false);

            }, 3000);
        }
    }, [success])
    useEffect(() => {
        if (text === "enrollNow") {
            inputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            inputRef.current.focus();
        }
    }, [fullnameError]);
    document.title = "ScaleUp Academy | Contact";

    return (
        <>
            <Helmet>
                <title>Contact Scaleup Academy | Best IT & Tech Institute in Pokhara, Nepal</title>

                {/* Geo Tags */}
                <meta name="geo.region" content="NP-GA" />
                <meta name="geo.placename" content="Pokhara" />
                <meta name="geo.position" content="28.2096;83.9856" />
                <meta name="ICBM" content="28.2096, 83.9856" />

                {/* SEO Meta Tags */}
                <meta
                    name="description"
                    content="Get in touch with Scaleup Academy, the best IT and tech institute in Pokhara, Nepal. Contact us for inquiries about our courses in Graphic Design, UI/UX, Digital Marketing, Video Editing, and more. Our expert instructors are ready to guide you."
                />
                <meta
                    name="keywords"
                    content="Contact Scaleup Academy, IT institute Pokhara, Tech courses Pokhara, Graphic Design classes Pokhara, UI/UX design Pokhara, Digital Marketing training, Video Editing course Pokhara"
                />
                <meta name="author" content="Scaleup Academy" />

                {/* Open Graph / Social Media Tags */}
                <meta property="og:title" content="Contact Scaleup Academy | Best IT & Tech Institute in Pokhara" />
                <meta
                    property="og:description"
                    content="Reach out to Scaleup Academy in Pokhara for inquiries about our IT and tech courses, including Graphic Design, UI/UX, Digital Marketing, and Video Editing. Start your career with expert guidance today."
                />
                <meta property="og:image" content="https://scale-upacademy.com/logo.png" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://scale-upacademy.com/contact" />

                {/* Optional: Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Contact Scaleup Academy | Best IT & Tech Institute in Pokhara" />
                <meta
                    name="twitter:description"
                    content="Contact Scaleup Academy in Pokhara to learn about our IT and tech courses in Graphic Design, UI/UX, Digital Marketing, and Video Editing. Our expert instructors are here to guide you."
                />
                <meta name="twitter:image" content="https://scale-upacademy.com/logo.png" />
            </Helmet>

            <NavBar fullNav={fullNav} />

            <div ref={topSc} className="contactPage">
                <div className='ctaBanner'> <span className='spant'></span> <span className='spanb'></span> <span className='spanr'></span> <div className="linear-gradient"></div> <div className="forContact"> <h2>Contact Us</h2> <h5>Connect with us</h5> </div> </div> <div className="ctaBannerContact"> <p>Let's <span>Kickstart</span> <br /></p><p>Your Learning <span className="span2">Journey</span></p>
                    <p >Join industry-expert-led programs and become job-ready in just a few months. Whether it's Graphic Design, UI/UX, Digital Marketing, Web Development, or Video Editing – your future career starts here.</p> <div className='ctaBtn contactBtnEnroll'> <Link className='boxAnimation' to={"https://api.whatsapp.com/send?phone=9779867733552&text=I%20am%20contacting%20you%20regarding%20an%20inquiry%20about%20Scaleup%20Academy.%0AName:%0ACourses:"}><span></span><div className='text'>Whatsapp Us</div></Link> </div> </div>
                {/* Your existing form structure */}
                {inputFields &&
                    <>
                        <div className="userDetails">
                            <div className="titleText">Let's Connect</div>
                            <div className="userDetailsInput">
                                <label ref={fullnameRef}>Full Name<div className="requiredInput">*</div></label>
                                <input

                                    ref={inputRef}
                                    value={fullname}
                                    name="Name"
                                    className={fullnameError ? "error" : ""}
                                    onChange={(e) => {
                                        setFullname(e.target.value);
                                        validateField("fullname", e.target.value);
                                    }}
                                    placeholder="eg. John Admire"
                                    type="text"
                                />
                                <div className="errorText">{fullnameError}</div>

                                <label>Email<div className="requiredInput">*</div></label>
                                <input
                                    ref={emailRef}
                                    value={email}
                                    name="email"
                                    className={emailError ? "error" : ""}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        validateField("email", e.target.value);
                                    }}
                                    placeholder="eg. example@exam.com"
                                    type="text"
                                />
                                <div className="errorText">{emailError}</div>

                                <label>Phone Number<div className="requiredInput">*</div></label>
                                <input
                                    ref={phoneRef}
                                    value={phone}
                                    className={phoneError ? "error" : ""}
                                    onChange={(e) => {
                                        setPhone(e.target.value);
                                        validateField("phone", e.target.value);
                                    }}
                                    placeholder="eg. 9860000000"
                                    type="text"
                                />
                                <div className="errorText">{phoneError}</div>
                            </div>
                        </div>

                        <div className="userDetails">
                            <div className="titleText">Which skill do you want to master?</div>
                            <div ref={courseRef} className="userDetailsInput">
                                <label>Courses<div className="requiredInput">*</div></label>
                                <div ref={divSecond} onClick={() => setDropDown(!dropdown)} className="select">
                                    <p>{courseselect === "" ? "Graphic Design | UI/UX Design, Digital Marketing, Web Development, App Development, Video Editing" : courseselect}</p>
                                </div>
                                {dropdown &&
                                    <div className="optionSelect">
                                        <div onClick={() => { setCourse("Graphic Design"); validateField("courseselect", "Graphic Design"); }} className="optionBox">Graphic Design</div>
                                        <div onClick={() => { setCourse("Web Development"); validateField("courseselect", "Web Development"); }} className="optionBox">Web Development</div>
                                        <div onClick={() => { setCourse("Marketing"); validateField("courseselect", "Marketing"); }} className="optionBox">Marketing</div>
                                        <div onClick={() => { setCourse("Video Editing"); validateField("courseselect", "Video Editing"); }} className="optionBox">Video Editing</div>
                                        <div onClick={() => { setCourse("CCNA Training"); validateField("courseselect", "CCNA Training"); }} className="optionBox">CCNA Training</div>

                                    </div>
                                }
                                <div className="errorText">{courseError}</div>
                            </div>
                        </div>

                        <div className="userDetails">
                            <div className="titleText">Preferred Date & Time</div>
                            <div className="userDetailsInput">
                                <label>Start Date</label>
                                <input
                                    ref={dateRef}
                                    value={date}
                                    className={dateError ? "error" : ""}
                                    onChange={(e) => {
                                        setDate(e.target.value);
                                        validateField("date", e.target.value);
                                    }}
                                    placeholder="eg. 2082/06/23"
                                    type="text"
                                />
                                <div className="errorText">{dateError}</div>

                                <label>Start Time</label>
                                <input
                                    ref={timeRef}
                                    value={time}
                                    className={timeError ? "error" : ""}
                                    onChange={(e) => {
                                        setTime(e.target.value);
                                        validateField("time", e.target.value);
                                    }}
                                    placeholder="eg. 10:00 AM"
                                    type="text"
                                />
                                <div className="errorText">{timeError}</div>
                            </div>
                        </div>

                        <div className="btnNerror">
                            <button disabled={load} onClick={submitForm} className="contactSubmitBtn"> <span>{load ? "Sending." : "Submit"}</span> <span>{load ? "Sending." : "Submit"}</span> </button>
                            {fetchError &&
                                <div className="serverResponse"> {fetchError} ,Try Again Later!</div>

                            }
                        </div>
                    </>
                }


            </div>
            {success &&
                <div className="messageSuccess">
                    <div className="popup-overlay">
                        <div className="popup-box" >
                            <h3>Message Sent Successfully</h3>
                            <p>Thank you for contacting us. We’ll get back to you shortly.</p>
                            <a href="tel:9867733552
                            " className="call-btn">
                                📞 Call Us Directly
                            </a>
                        </div>
                    </div>
                </div>
            }


            <Map />
            <GetReady clean={true} logo={false} />
            <Footer />
        </>
    );
};

export default Contact;
